"use strict";

module.exports = function isObject(x) {
	return typeof x === "object" && x !== null;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/virtual-dom/~/is-object/index.js
 ** module id = 150
 ** module chunks = 0
 **/